import React, { Component } from 'react';
import Clappr from 'clappr';

class ClapprPlayer extends Component {
    componentDidMount() {
        this.change(this.props.source, this.props.poster);
    }

    componentWillUnmount() {
        this.destroyPlayer();
    }

    shouldComponentUpdate(nextProps, nextState) {
        let changed = (nextProps.source != this.props.source);
        this.props = nextProps;
        this.state = nextState;
        if (changed) {
            this.change(nextProps.source, nextProps.poster);
        }
        return false;
    }

    destroyPlayer() {
        if (this.player) {
            this.player.destroy();
        }
        this.player = null;
    }

    change(source, poster) {
        if (this.player) {
            this.destroyPlayer();
        }
        this.player = new Clappr.Player({
            parent: this.refs.player,
            poster: poster,
            source: source,
            width: '100%',
            height: '100%',
            autoPlay: true,
            type: 'application/x-mpegURL',
            rtmpConfig: {
                playbackType: 'live'
            }
        });
    }

    render() {
        return (
            <div className="video-player">
                <div style={{height: '100%'}} ref="player"></div>
            </div>
        );
    }
}

export default ClapprPlayer;


// WEBPACK FOOTER //
// ./src/components/ClapprPlayer/ClapprPlayer.js